import { findKey } from 'lodash'

export const smokingMap = {
  0: '指定なし',
  1: '喫煙',
  2: '非喫煙',
}

export function getSmokingCodeByStr(smokingStr) {
  return parseInt(
    findKey(smokingMap, mapStr => mapStr === smokingStr),
    10,
  )
}
